/** Sources the API reports that the shared `RiskRatingSource` enum does not name yet. */
export enum ExtendedRiskRatingSource {
  BandChange = 'band_change',
  /** No result and no rationale behind it - the rating as it stood at the backfill. */
  Seeded = 'seeded'
}
